import { ViewModel } from "../mvvm/ViewModel.js";
/** Platform console: money paid to the platform (all sites) and per-site payment actions. */
export class PlatformPaymentsViewModel extends ViewModel {
    client;
    constructor(client) {
        super({ payments: [], totals: null, sitePayments: [] });
        this.client = client;
    }
    /** Throws on failure so a LivePanel can surface it. */
    async loadAll(filters) {
        const res = await this.client.listAllPayments(filters);
        this.setState({ payments: res.payments, totals: res.totals });
    }
    syncStripe() {
        return this.client.syncStripePayments();
    }
    async loadSite(slug) {
        this.setState({ sitePayments: await this.client.listPayments(slug) });
    }
    recordPayment(slug, input) {
        return this.client.recordPayment(slug, input);
    }
    runSplit(slug, paymentId) {
        return this.client.runPaymentSplit(slug, paymentId);
    }
}
//# sourceMappingURL=PlatformPaymentsViewModel.js.map